module.exports = __webpack_public_path__ + "static/media/logoMarcaPonto.d4a9957d.png";